export default "__VITE_ASSET__CLJpCRHt__"